import { FC, useEffect, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { TbPencil } from 'react-icons/tb';

import { ActionIcon, Button, Flex, Text, TextInput } from '@mantine/core';

import { Title } from './Title';

const EditableTitle: FC<{
    title: string;
    onSave: (newTitle: string) => Promise<void>;
    fontSize?: number;
}> = ({ title, onSave, fontSize = 32 }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tempTitle, setTempTitle] = useState(title);

    useEffect(() => setTempTitle(title), [title]);

    const saveTitle = async () => {
        setIsLoading(true);
        await onSave(tempTitle);
        setIsLoading(false);

        setIsEditing(false);
    };

    useHotkeys('esc', () => setIsEditing(false), {
        enableOnFormTags: ['input'],
    });

    useHotkeys('enter', saveTitle, {
        enableOnFormTags: ['input'],
    });

    if (isEditing) {
        return (
            <Flex align="center" gap={4} display="inline-flex">
                <TextInput
                    value={tempTitle}
                    onChange={(event) => {
                        setTempTitle(event.target.value);
                    }}
                    disabled={isLoading}
                    styles={() => ({
                        input: {
                            width: 'auto',
                            height: 'auto',
                            minHeight: 'auto',
                            lineHeight: 'initial',

                            padding: 0,
                            fontSize,
                            fontWeight: 700,
                        },
                    })}
                />
                <Button onClick={saveTitle} loading={isLoading} variant="outline" size="compact-sm">
                    Save
                </Button>
            </Flex>
        );
    }
    return (
        <Flex align="center" gap="xs">
            <Title fz={fontSize}>{title}</Title>
            <ActionIcon onClick={() => setIsEditing(true)} variant="light" size="sm">
                <Text c="dimmed" display="flex">
                    <TbPencil size={14} strokeWidth={1.5} />
                </Text>
            </ActionIcon>
        </Flex>
    );
};

export { EditableTitle };
